(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-funnel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('book-funnel')) {
  customElements.define('book-funnel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-order-form]');
      this.bumps = [...this.querySelectorAll('[data-bump]')];
      this.error = this.querySelector('[data-error-message]');
      this.querySelector('[data-bumps]').hidden = false;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.bumps.forEach(input => input.addEventListener('change', () => this.updateTotal()));
      this.form.addEventListener('submit', event => this.checkout(event));
      window.addEventListener('pageshow', () => { this.unlock(); this.updateTotal(); });
      this.updateTotal();
    }
    updateTotal() {
      const total = this.bumps.reduce((sum, input) => sum + (input.checked ? Number(input.dataset.price) : 0), Number(this.dataset.basePrice));
      this.querySelector('[data-subtotal]').textContent = this.money.format(total / 100);
    }
    unlock() {
      const button = this.form.querySelector('[type="submit"]');
      if (button && this.originalButton) button.innerHTML = this.originalButton;
      if (button) button.disabled = false;
      this.form.removeAttribute('aria-busy');
      this.bumps.forEach(input => input.disabled = false);
      this.pending = false;
    }
    async request(path, body) {
      const options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
      if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
      const response = await fetch(this.dataset.root + path, options);
      let data;
      try { data = await response.json(); } catch { throw new Error(this.dataset.error); }
      if (!response.ok || data.status >= 400) throw new Error(data.description || this.dataset.error);
      return data;
    }
    async checkout(event) {
      event.preventDefault();
      if (this.pending) return;
      this.pending = true;
      this.error.hidden = true;
      const button = this.form.querySelector('[type="submit"]');
      this.originalButton ||= button.innerHTML;
      button.textContent = this.dataset.busy;
      button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      const desired = new Map([[String(this.form.querySelector('[data-main-variant]').value), 'book']]);
      this.bumps.filter(input => input.checked).forEach(input => desired.set(String(input.value), input.dataset.role));
      this.bumps.forEach(input => input.disabled = true);
      try {
        const cart = await this.request('cart.js');
        const found = new Set();
        const updates = {};
        for (const item of cart.items) {
          if (item.properties?._cw_funnel !== this.dataset.funnel) continue;
          const id = String(item.variant_id);
          const quantity = desired.has(id) && !found.has(id) ? 1 : 0;
          if (quantity) found.add(id);
          if (item.quantity !== quantity) updates[item.key] = quantity;
        }
        if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
        const items = [...desired].filter(([id]) => !found.has(id)).map(([id, role]) => ({ id: Number(id), quantity: 1, properties: { _cw_funnel: this.dataset.funnel, _cw_offer: role } }));
        if (items.length) await this.request('cart/add.js', { items });
        window.location.assign(this.dataset.root + 'checkout');
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        this.unlock();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
